import React from 'react'
import Code from './Code'
import Header from './Header'
import Result from './Result'

function Home() {
  return (
    <>
     <Header/>
     <Code/>
     <Result/>
    </>
  )
}

export default Home
